<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('ecgDesc.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="desc-content">
            <div class="desc-box">
                <div class="desc-title">{{ $t('ecgDesc.title0') }}</div>
                <div class="desc-info">
                    {{ $t('ecgDesc.desc0') }}
                    <div class="score-li">{{ $t('ecgDesc.level0') }}</div>
                    <div class="score-li">{{ $t('ecgDesc.level1') }}</div>
                    <div class="score-li">{{ $t('ecgDesc.level2') }}</div>
                    <div class="score-li">{{ $t('ecgDesc.level3') }}</div>
                    <div class="score-li">{{ $t('ecgDesc.level4') }}</div>
                </div>
                <div class="desc-title">{{ $t('ecgDesc.title1') }}</div>
                <div class="desc-info last-desc">{{ $t('ecgDesc.desc1') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '04ecgDesc',
    data() {
        return {
            theme: 'light'
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        }
    },
}
</script>

<style scoped>
.score-li {
    margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/04ecgDesc.vue